import { useEffect } from "react";


const NPFForm = () => {
    useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://widgets.in6.nopaperforms.com/emwgts.js";
    script.async = true;
    script.type = "text/javascript";

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="npf_wgts"
      data-height="600px"
      data-w="3f4274baec4df825dd72c5ff92d085ff"
    ></div>
  );
}

export default NPFForm;